import i18n from '@/i18n';
import { validateEmail, validateEAN } from '@/utils/validate';

export function validatorEmail(rule, value, callback) {
  if (value && !validateEmail(value)) {
    callback(new Error(i18n.t('validation.email')));
  } else {
    callback();
  }
}
export function validatorRequiredObject(rule, value, callback) {
  if (Object.keys(value) === 0 || !Object.values(value).some(v => v > 0)) {
    callback(new Error(i18n.t('validation.required')));
  } else {
    callback();
  }
}
export function validatorRequireNumber(rule, value, callback) {
  if ((value !== 0 && !value) || value.length === 0) {
    callback(new Error(i18n.t('validation.required')));
  } else {
    callback();
  }
}
export function validatorRequire(rule, value, callback) {
  if (!value || value.length === 0) {
    callback(new Error(i18n.t('validation.required')));
  } else {
    callback();
  }
}
export function validatorRequiredRating(rule, value, callback) {
  if (!(value >= 1 && value <= 5)) {
    callback(new Error(i18n.t('validation.complexity')));
  } else {
    callback();
  }
}

export function validatorRequireMultipleSelect(rule, value, callback) {
  if (value.length === 0) {
    callback(new Error(i18n.t('validation.required')));
  } else {
    callback();
  }
}

export function validatorEAN(rule, value, callback) {
  if (value.length > 0 && !validateEAN(value)) {
    callback(new Error(i18n.t('validation.ean')));
  } else {
    callback();
  }
}
